export const stateName = 'intl' as const
